import {Ventrata} from 'types'

type Props = {
  usedUnits: Ventrata.Unit[]
  counters: Record<string, number>
}

export const UnitsPerBooking = ({usedUnits, counters}: Props) => (
  <div className="py-4 flex flex-col gap-2">
    <h3 className="uppercase text-gray-500 text-xs">Guests</h3>

    {usedUnits.map((unit) => {
      const counter = counters[unit.id]
      return (
        <div key={unit.id} className="flex justify-between">
          <div>
            {unit.title} x {counter}
          </div>
        </div>
      )
    })}
  </div>
)
